// Cart drawer: strap carousel arrows + "+ Add" (re-renders the drawer through Dawn's own sections API).
document.addEventListener('click', (e) => {
  const dir = e.target.closest('[data-mv-up-dir]');
  if (dir) { const t = dir.parentElement.querySelector('[data-mv-up-track]'); if (t) t.scrollBy({ left: +dir.dataset.mvUpDir * t.clientWidth }); return; }
  const add = e.target.closest('[data-mv-up-add]');
  if (!add) return;
  const drawer = document.querySelector('cart-drawer'); if (!drawer) return;
  add.disabled = true; add.textContent = 'Adding…';
  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: +add.dataset.mvUpAdd, quantity: 1 }], sections: drawer.getSectionsToRender().map((s) => s.id), sections_url: window.location.pathname }),
  }).then((r) => r.json()).then((res) => { if (!res.status) drawer.renderContents(res); else { add.disabled = false; add.textContent = '+ Add'; } });
});

// Our add buttons (Buy 1 get 1, straps) call renderContents directly, so clear the drawer's empty state the way Dawn's product form does.
customElements.whenDefined('cart-drawer').then(() => {
  const proto = customElements.get('cart-drawer').prototype, render = proto.renderContents;
  proto.renderContents = function (state) { this.classList.remove('is-empty'); return render.call(this, state); };
});

// "Remove" on a watch also removes its free watch (data-mv-remove = the line keys to zero).
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-mv-remove]');
  const drawer = btn && document.querySelector('cart-drawer'); if (!drawer) return;
  btn.disabled = true;
  const updates = Object.fromEntries(btn.dataset.mvRemove.split(',').map((k) => [k, 0]));
  fetch(window.routes.cart_update_url + '.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates, sections: drawer.getSectionsToRender().map((s) => s.id), sections_url: window.location.pathname }),
  }).then((r) => r.json()).then((res) => { drawer.renderContents(res); drawer.classList.toggle('is-empty', !res.item_count); }).catch(() => { btn.disabled = false; });
});
